import { Component, inject, input, output } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { collection, addDoc } from '@angular/fire/firestore';
import { UtilityHelper } from 'utility-lib';
import { AuthService } from '../../services/auth.service';
import { EmailService } from '../../services/email.service';
import { FIRESTORE } from '../../../fireauth-lib.config';

@Component({
  selector: 'app-invite-user',
  imports: [ReactiveFormsModule],
  templateUrl: './invite-user.component.html',
  styleUrls: ['./invite-user.component.css']
})
export class InviteUserComponent {
  userRoles = input.required<string[]>(); // ['Editor', 'Reader']
  isEmulator = input.required<boolean>();
  onUserInvited = output<any>();

  fb = inject(FormBuilder);
  private firestore = inject(FIRESTORE);
  private authService = inject(AuthService);
  emailService = inject(EmailService);

  inviteForm: FormGroup;

  constructor() {
    this.inviteForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
      role: ['', [Validators.required]] // 'Editor' or 'Reader'
    });
  }

  async sendInvite() {
    if (this.inviteForm.invalid) return;

    const { email, role } = this.inviteForm.value;
    const token = UtilityHelper.generateRandomToken();
    const expiresAt = new Date();
    expiresAt.setDate(expiresAt.getDate() + 7); // Expiration after 7 days
    //get current user orgCode from FirebaseAuth currentUser
    const orgCode = this.authService.currentUser()?.orgCode;
    // Save invite to Firestore
    const inviteRef = collection(this.firestore, 'InvitedUsers');
    await addDoc(inviteRef, { email, role, orgCode, token, expiresAt, accepted: false });

    // Send invite email
    const baseUrl = window.location.origin; // Dynamically gets the current domain
    const inviteUrl = `${baseUrl}/accept-invite?token=${token}`;
    this.emailService.sendInviteEmail(email, inviteUrl, this.isEmulator());
    console.log('Invite sent successfully!',inviteUrl);

    alert('Invitation sent successfully!');
    this.inviteForm.reset();
    this.onUserInvited.emit({ email, role, inviteUrl, token, expiresAt });
  }
}